import {useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { getDarReportspecificEmp, getEmployeeListByUnit, getExpenseByEmployeeId, getExpenseDetails, getExpenseFWDetails, getExpenseListAllUnit, getExpenseListByDate, getExpenseLog, getExpenseNCADetails, getExpenseStatus, updateExpenseAmount, UpdateExpenseStatus_proceedToPayment } from "./ExpenseRepository";
import { showToast } from "../../../utils/toastUtils";

export const useExpenseListDataAllUnit = ({ enable = false, params = {} }: { params?: Record<string,any>; enable?: boolean } = {}) => {
    return useQuery({
        queryKey: ["GET_EXPENSE_LIST_ALL_UNIT",params],
        queryFn: ()=>getExpenseListAllUnit(params),
        enabled: enable,
        retry: false,
        //   staleTime: 5 * 60 * 1000,
    });
};

export const useEmployeeListByUnit = ({
    enable = false,
    params = {},
    id,
  }: {
    params?: Record<string, any>;
    enable?: boolean;
    id: number;
  }) => {
    return useQuery({
      queryKey: ["GET_EMPLOYEE_LIST", params, id],
      queryFn: () => getEmployeeListByUnit(params, id),
      enabled: enable,
      retry: false,
    });
  };

  export const useExpenseByEmployeeId = ({
    enable = false,
    params = {},
    id,
  }: {
    params?: Record<string, any>;
    enable?: boolean;
    id: number;
  }) => {
    return useQuery({
      queryKey: ["GET_EXPENSE_BY_EMPLOYEE_ID", params, id],
      queryFn: () => getExpenseByEmployeeId(params, id),
      enabled: enable,
      retry: false,
    });
  }

  export const useExpenseListByDate = ({
    enable = false,
    params = {},
    id,
  }: {
    params?: Record<string, any>; 
    enable?: boolean;
    id: number;
  }) => {
    return useQuery({
      queryKey: ["GET_EXPENSE_LIST_BY_DATE", params, id],
      queryFn: () => getExpenseListByDate(params, id),
      enabled: enable,
      retry: false,
    });
  }

  export const useExpenseDetails = ({
    enabled  = false,
    id,
  }: {
    enabled ?: boolean;
    id: number;
  }) => {
    return useQuery({
      queryKey: ["GET_EXPENSE_DETAILS", id],
      queryFn: () => getExpenseDetails(id),
      enabled,
      retry: false,
    });
  }

  export const useExpenseFWDetails = ({
    enabled,
    empId,
    params = {},
  }: {
    enabled: boolean;
    empId: number;
    params: Record<string, any>;
  }) => {  
    return useQuery({
      queryKey: ["GET_EXPENSE_FW_DETAILS", empId, params.date],
      queryFn: () => getExpenseFWDetails(empId, params),
      enabled,
      retry: false,
    });
    
  };


  export const useExpenseNCADetails = ({
    enabled,
    empId,
    params = {},
  }: {
    enabled: boolean;
    empId: number;
    params: Record<string, any>;
  }) => {
    return useQuery({
      queryKey: ["GET_EXPENSE_NCA_DETAILS", empId, params.date],
      queryFn: () => getExpenseNCADetails(empId, params),
      enabled,
      retry: false,
    });
  };

  export const useExpenseLog = ({
    enabled  = false,
    id,
    params
  }: {
    enabled ?: boolean;
    id: number;
    params:Record<string,any>;
  }) => {
    return useQuery({
      queryKey: ["GET_EXPENSE_DETAILS", id,params],
      queryFn: () => getExpenseLog(id,params),
      enabled,
      retry: false,
    });
  }
  

  export const useUpdateExpenseAmount = ()=>{
    const queryClient  = useQueryClient();
    return useMutation({
        
     mutationFn:({id,ReqBody}:{id:number,ReqBody:Record<string,any>})=>updateExpenseAmount(id,ReqBody),
     
     onSuccess:()=>{
     showToast.success('Expense Amount Successfully');
     queryClient.invalidateQueries({queryKey:['GET_EXPENSE_LIST_BY_DATE']});
     queryClient.invalidateQueries({queryKey:['GET_EXPENSE_DETAILS']});
     },
     onError:(error:any)=>{
      showToast.error('Failed to Update Expense Amount');
      console.log(`Flird to Update${error.message}`)
     }
    })
  }

export const useExpenseList =({enable=false})=>{
   return useQuery({
    queryKey:['GET_EXPENSE_AUDUIT_STATUS'],
    queryFn:getExpenseStatus,
    enabled:enable,
    retry:false,
   })
}


export const useGetDarReport =({enable=false,params}:{enable:boolean,params:any})=>{
   return useQuery({
    queryKey:['GET_DAR_REPORT_EXPENSE',params],
    queryFn:()=>getDarReportspecificEmp(params),
    enabled:enable,
    retry:false,
   })
}

export const useUpdateExpeseAmounnt_ProceedToPayment=()=>{
  const queryClient = useQueryClient();
    return useMutation({
      mutationFn:(ReqBody:any)=>UpdateExpenseStatus_proceedToPayment(ReqBody),
      onSuccess:()=>{
        queryClient.invalidateQueries({queryKey:['']})
        showToast.success('Status Update Successfully');
      },
      onError:(error)=>{
        console.log('Error',error);
        showToast.success('Falied Status Update');
      }
    })
  }





